module.exports = __webpack_public_path__ + "img/63ne.4fc826be.svg";